export const FIND_OPEN_PROCESS_STATEMENT_REQUEST = 'FIND_OPEN_PROCESS_STATEMENT_REQUEST';

export const findOpenProcessStatementRequest = ( id ) => ({
    type: FIND_OPEN_PROCESS_STATEMENT_REQUEST,
    payload: { id }
});
